import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import styles from './styles.js';

class PortalBanner extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { classes, message, onYes, onNo, onRemindLater } = this.props;

    return (
      <div className={classes.root}>
        <div className={classes.wrapper}>
          <div className={classes.textWrapper}>
            <Typography
              component="span"
              variant="body2"
              className={classes.message}
              dangerouslySetInnerHTML={{ __html: message }}
            ></Typography>
          </div>
          <div className={classes.buttonWrapper}>
            <Button
              onClick={onYes}
              variant="outlined"
              color="primary"
              className={classes.button}
            >
              Yes
            </Button>
            <Button
              onClick={onNo}
              variant="outlined"
              color="primary"
              className={classes.button}
            >
              No
            </Button>
            <Button
              onClick={onRemindLater}
              variant="outlined"
              color="primary"
              className={classes.button}
            >
              Remind me later
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(PortalBanner);
